import React, { useEffect, useState } from 'react';
import { supabase } from './supabaseClient';

function chunkArray(array, size) {
  const result = [];
  for (let i = 0; i < array.length; i += size) {
    result.push(array.slice(i, i + size));
  }
  return result;
}

export default function PrintPage({ filter, onBack }) {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    let query = supabase.from('products').select('*');
    if (filter.namaProduk.length > 0) {
      query = query.in('nama produk', filter.namaProduk);
    }
    if (filter.kategori.length > 0) {
      query = query.in('kategori', filter.kategori);
    }
    query.then(({ data }) => {
      setProducts(data || []);
    });
  }, [filter]);

  const pages = chunkArray(products, 9);

  return (
    <div>
      <button onClick={onBack} style={{ margin: 20 }}>Kembali ke Filter</button>
      <button onClick={() => window.print()} style={{ margin: 20 }}>Print</button>
      {pages.map((page, idx) => (
        <div
          key={idx}
          className="print-page"
          style={{
            pageBreakAfter: 'always',
            width: '210mm',
            minHeight: '297mm',
            margin: 'auto',
            display: 'flex',
            flexWrap: 'wrap',
            background: '#fff',
            boxSizing: 'border-box',
            padding: 20,
          }}
        >
          {page.map((prod, i) => (
            <div
              key={prod.id}
              style={{
                width: '32.5%',
                margin: '0.25%',
                boxSizing: 'border-box',
                border: '1px solid #ccc',
                borderRadius: 8,
                padding: 4,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                minHeight: 220,
                maxHeight: 300,
                overflow: 'hidden',
                position: 'relative',
                background: '#fff',
              }}
            >
              <div style={{width: '100%', padding: 0, margin: 0}}>
                <div
                  style={{
                    fontWeight: 'bold',
                    fontSize: `clamp(10px, 1.2vw, 15px)`,
                    width: '100%',
                    textAlign: 'center',
                    margin: 0,
                    lineHeight: 1.1,
                    wordBreak: 'break-word',
                    display: 'block',
                    minHeight: 18,
                    maxHeight: 32,
                    overflow: 'hidden',
                  }}
                  title={prod['nama produk']}
                >
                  {prod['nama produk']}
                </div>
                <div style={{ color: '#333', fontSize: 13, textAlign: 'center', margin: 0 }}>Harga: Rp {prod.harga}</div>
                {prod.diskon ? (
                  <div style={{ color: 'red', fontSize: 13, textAlign: 'center', margin: 0 }}>Diskon: {prod.diskon}%</div>
                ) : null}
                <div style={{ width: '100%', borderTop: '1px solid #eee', margin: '4px 0 0 0' }}></div>
              </div>
              <img
                src={`https://tpkafgnufwbqcdhiviwo.supabase.co/storage/v1/object/public/product-images/${prod.gambar}`}
                alt={prod['nama produk']}
                style={{ width: '100%', height: 180, objectFit: 'contain', margin: 0, marginTop: 4 }}
                onError={e => (e.target.style.display = 'none')}
              />
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
